import "./sass/main.scss"

document.onload = init();

function init() {
  import(/* webpackPrefetch: true */ "./js/web/scroll").then(({ Scrollstart }) => {
    Scrollstart()
  });
 
}